export default __webpack_public_path__ + "static/media/failure-gray.icon.be93d9f1.svg";